import { render, staticRenderFns } from "./VasionButton.vue?vue&type=template&id=0df7abae&scoped=true"
import script from "./VasionButton.vue?vue&type=script&lang=js"
export * from "./VasionButton.vue?vue&type=script&lang=js"
import style0 from "./VasionButton.vue?vue&type=style&index=0&id=0df7abae&prod&lang=scss"
import style1 from "./VasionButton.vue?vue&type=style&index=1&id=0df7abae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df7abae",
  null
  
)

export default component.exports